/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostFreeTrialSuccessResponse
 */
export interface PostFreeTrialSuccessResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof PostFreeTrialSuccessResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof PostFreeTrialSuccessResponse
     */
    message: string;
}

export function PostFreeTrialSuccessResponseFromJSON(json: any): PostFreeTrialSuccessResponse {
    return PostFreeTrialSuccessResponseFromJSONTyped(json, false);
}

export function PostFreeTrialSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostFreeTrialSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function PostFreeTrialSuccessResponseToJSON(value?: PostFreeTrialSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

